import * as React from "react";
import styled from "styled-components";
import TacticsChart from "security-app/components/common/ThreatCoverageWidget/TacticsChart";
import TacticsList from "security-app/components/common/ThreatCoverageWidget/TacticsList";
import { Timestamp } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { Alert } from "components/bootstrap";
import permissions from "security-app/Permissions";
export const RENDER_TYPE = "threat_coverage";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ThreatCoverageExportPage = ({ data }) => {
  const { userTimezone } = useUserDateTime();
  const currentUser = useCurrentUser();
  if (!isPermitted(currentUser == null ? void 0 : currentUser.permissions, permissions.securityApp.read)) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "You are not permitted to view this page.");
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h1", { className: "has-bm" }, "Threat Coverage"), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TacticsChart, { tactics: data.data.elements }), /* @__PURE__ */ React.createElement(TacticsList, { tactics: data.data.elements }), /* @__PURE__ */ React.createElement("p", null, "Created at ", /* @__PURE__ */ React.createElement(Timestamp, { dateTime: /* @__PURE__ */ new Date() }), " (", userTimezone, ")")));
};
export default ThreatCoverageExportPage;
